import './index.css';
import { styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import Constants from '../../constants';
import useTheme from '../../utilities/hooks/theme';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import Button from '@mui/material/Button/Button';
import View from '../view';
import React from 'react';

const ColorlibConnector = styled(StepConnector)(() => {
  const { ProfileTheme: myTheme } = useTheme();
  return {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 14
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: myTheme.stepIndicatorLabelFinishedColor
      }
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: myTheme.stepIndicatorLabelFinishedColor
      }
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 5,
      border: 0,
      backgroundColor: myTheme.stepIndicatorLabelUnFinishedColor,
      borderRadius: 1
    }
  };
});

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean; myTheme?: any };
}>(
  (
    // eslint-disable-next-line no-empty-pattern
    {
      // theme, ownerState
    }
  ) => ({
    zIndex: 1,
    width: 30,
    height: 30,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  })
);

const steps = ['Phone', 'Email', 'Pan', 'Bank', 'Address'];
interface Props {
  verificationStep?: number;
  onPressCompletedVerification?: any;
  isVerified?: boolean;
  statuses?: any;
}
const ProfileVerification = ({
  verificationStep,
  onPressCompletedVerification,
  isVerified,
  statuses
}: Props) => {
  const {
    bankAccounts: bankAccountStatus,
    pan: panStatus,
    emails: emailsStatus,
    phones: phonesStatus,
    addresses: addressesStatus
  } = statuses;

  const { ProfileTheme: myTheme } = useTheme();
  const labelSx: SxProps<Theme> = {
    '& .MuiStepLabel-label': {
      color: myTheme.stepIndicatorLabelActiveColor,
      fontSize: 'small',
      fontFamily: 'ProximaNova-Regular',
      textTransform: 'none'
    },
    '& .MuiStepLabel-label.Mui-completed': {
      color: myTheme.stepIndicatorLabelFinishedColor,
      fontFamily: 'ProximaNova-SemiBold',
      textTransform: 'none'
    },
    '& .MuiStepLabel-label.Mui-active': {
      color: myTheme.stepIndicatorLabelActiveColor
    }
  };
  const completeVerificationBtn = {
    backgroundColor: myTheme.profileIndicatorBtn,
    borderColor: myTheme.profileIndicatorBtnBorder,
    color: myTheme.profileIndicatorBtnLabel
  };
  const profileIndicatorWrapperBG = {
    backgroundColor: myTheme.profileIndicatorBG
  };

  function ColorlibStepIcon(props: StepIconProps) {
    const { ProfileTheme: myTheme } = useTheme();
    const { active, className, icon = 0 } = props;
    let completed = false;
    if (icon == 1 && phonesStatus === 'verified') {
      completed = true;
    } else if (icon == 2 && emailsStatus === 'verified') {
      completed = true;
    } else if (icon == 3 && panStatus === 'verified') {
      completed = true;
    } else if (icon == 4 && bankAccountStatus === 'verified') {
      completed = true;
    } else if (icon == 5 && addressesStatus === 'verified') {
      completed = true;
    }
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active, myTheme }} className={className}>
        {completed ? (
          <Constants.Svgs.VerificationCheck width={30} height={30} />
        ) : (
          <Constants.Svgs.VerificationUnCheck width={30} height={30} />
        )}
      </ColorlibStepIconRoot>
    );
  }

  return (
    <View style={profileIndicatorWrapperBG} className={'profile-verification-container'}>
      <Stepper alternativeLabel activeStep={verificationStep} connector={<ColorlibConnector />}>
        {steps.map((label) => {
          return (
            <Step key={label}>
              <StepLabel property={statuses} sx={labelSx} StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <View className={'profile-verification--btn-container'}>
        <Button
          onClick={onPressCompletedVerification}
          className="profile-verification-btn"
          style={completeVerificationBtn}>
          {isVerified ? 'View KYC Details' : 'Complete KYC'}
        </Button>
      </View>
    </View>
  );
};
export default React.memo(ProfileVerification);
